export const STATES = {
  NOT_SELECTED: 'SHIPPING_METHOD_NOT_SELECTED',
  EVALUATE_NEED_FOR_ADDITIONAL_INFO: 'NEED_ADDITIONAL_INFO_FOR_SHIPPING_METHOD',
  PICKUP_POINT_SELECTION: 'NEED_PICKUP_POINT_SELECTION',
  SELECTED: 'SHIPPING_METHOD_SELECTED',
};
